import { decorate, observable, action } from 'mobx';
import * as Api from '../lib/api';

export class RequestStore {
    loading = false;
    success = false;
    successMessage = '';
    errorMessage = '';

    submitForm1 = (values, onClose) => {
        this.loading = true;
        const data = {
            ...values,
            utm: 'utm_lk_nettehniki',
        };

        Api.fetch('product/not_found', data, 'post')
            .then(response => {
                if (response?.success && response.result) {
                    this.success = true;
                    this.successMessage = response.result?.message;
                }
            })
            .catch(response => {
                if (!response?.success) {
                    this.success = false;
                    this.errorMessage = response.error_description;
                }
            })
            .finally(() => {
                this.loading = false;
                setTimeout(() => {
                    this.success = false;
                    onClose();
                }, 3000);
            });
    };

    submitForm2 = (values, onClose) => {
        this.loading = true;
        const data = {
            ...values,
            utm: 'utm_lk_inzhiniring',
        };

        Api.fetch('product/task', data, 'post')
            .then(response => {
                if (response?.success && response.result) {
                    this.success = true;
                    this.successMessage = response.result?.message;
                }
            })
            .catch(response => {
                if (!response?.success) {
                    this.success = false;
                    this.errorMessage = response.error_description;
                }
            })
            .finally(() => {
                this.loading = false;
                setTimeout(() => {
                    this.success = false;
                    onClose();
                }, 3000);
            });
    };
}

decorate(RequestStore, {
    loading: observable,
    success: observable,
    successMessage: observable,
    errorMessage: observable,

    submitForm1: action,
    submitForm2: action,
});
